export default "__VITE_ASSET__BoPpNWKK__"